module.exports = __webpack_public_path__ + "static/img/Treadplate.8dd0821.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-2/Treadplate.png
// module id = g7+3
// module chunks = 12